<head>
  <link rel="stylesheet" href="edit-user.component.css" importance="1">
    
    <!-- <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css"> -->
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <link href="https://unpkg.com/@angular/material/prebuilt-themes/indigo-pink.css" rel="stylesheet">
  </head>

  <div class="modal-overlay"></div>
  <div class="new-modal blue-grey lighten-5">
      <h4 mat-dialog-title class="modal-heading white">Edit User Record</h4>
   
      <div mat-dialog-content class="modal-content">
          <form #form="ngForm" (ngSubmit)="onSubmit()">
         <input type="text" placeholder="Enter First Name" id="Fname">
         <input type="text" placeholder="Enter Last Name">
         <input type="text" placeholder="Enter Company Name">
         <input type="text" placeholder="Enter Email">       
         <label for="usertype">Account Type:</label>
         <select style="display: block;" name="usertype" id="usertype">
             <option value="1" selected>Individual</option>
             <option value="2">Company Admin</option> 
             <option value="3">Company Staff</option>
         </select>
        </form>

      <div mat-dialog-actions>
        <button mat-button (click)="close()" class="modal-button">Close</button>
      </div>
    </div>
      
  </div>
  